<template>
  <v-card>
    <v-card-title primary-title class="warning lighten-2">
      {{ label }}
    </v-card-title>
    <v-card-text class="pt-2">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" colspan="2">ระยะเวลา Period</th>
              <th class="text-center" rowspan="2">
                ชื่อและที่อยู่ของบริษัท Name & Address Companies
              </th>
              <th class="text-center" rowspan="2">โทรศัพท์ Telephone</th>
              <th class="text-center" rowspan="2">ตำแหน่ง Position</th>
              <th class="text-center" rowspan="2">เงินเดือน Salary</th>
              <th class="text-center" rowspan="2">
                เหตุผลที่ลาออก Reason of leaving
              </th>
            </tr>
            <tr>
              <th class="text-center">ตั้งแต่ From</th>
              <th class="text-center">ถึง To</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="index in 5" :key="index">
              <td>
                <v-select
                  label="ตั้งแต่"
                  v-model="$store.state.dataFrm.list_hiswork.his_begin[index-1]"
                  :items="$store.getters.get_ListYear"
                  item-text="yearStr"
                  item-value="yearStr"
                ></v-select>
              </td>
              <td>
                <v-select
                  label="ถึง"
                  v-model="$store.state.dataFrm.list_hiswork.his_end[index-1]"
                  :items="$store.getters.get_ListYear"
                  item-text="yearStr"
                  item-value="yearStr"
                ></v-select>
              </td>
              <td>
                <v-text-field
                  label="ชื่อและที่อยู่ของบริษัท"
                  v-model="$store.state.dataFrm.list_hiswork.his_office[index-1]"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  label="โทรศัพท์"
                  v-model="$store.state.dataFrm.list_hiswork.his_phone[index-1]"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  label="ตำแหน่ง"
                  v-model="$store.state.dataFrm.list_hiswork.his_position[index-1]"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  label="เงินเดือน"
                  v-model="$store.state.dataFrm.list_hiswork.his_salary[index-1]"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  label="เหตุผลที่ลาออก"
                  v-model="$store.state.dataFrm.list_hiswork.his_remark_reject[index-1]"
                ></v-text-field>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>
<script>
// import datetimepicker_TH from "./datetimepickerTH";
export default {
  data() {
    return {
    };
  },
  components: {
    // datetimepicker_TH,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
  },
  computed: {},
};
</script>
